import { Board } from "./Components/Board/Board";
import { BoardManagerProvider } from "../BoardsManagerProvider";

interface SprintBoardProps { sprintId: number, GroupID?: number, IDAccount?: number }

export const SprintBoard = ({ sprintId, GroupID, IDAccount }: SprintBoardProps) => {
    return (
        <BoardManagerProvider
            sprintId={sprintId}
            GroupID={GroupID}
            IDAccount={IDAccount}
        >
            <Board />
        </BoardManagerProvider>
    );
};